<div
    class="inset-0 min-w-0 text-center"
    cdkScrollable>

    <!-- Main -->
    <div 
        [id]="printSectionId"
        class="inline-block text-left p-0">

        <!-- PurchaseOrder -->
        <div id="purchase-order-content" class="w-240 p-16 rounded-2xl shadow bg-card print:w-auto print:rounded-none print:shadow-none print:bg-transparent">

            <div class="flex items-start justify-between">
                <div class="grid grid-cols-2 gap-x-4 gap-y-1">
                    <div class="col-span-2 text-4xl tracking-tight">{{purchaseOrder?.isProduct ? 'SALES' : purchaseOrder?.isSupplier ? 'PURCHASE' : 'HIRE'}} ORDER ACKNOWLEDGEMENT</div>
                    <div class="font-medium tracking-tight mt-4">DATE</div>
                    <div class="font-medium mt-4">{{ purchaseOrder?.date | date: 'mediumDate' }}</div>
                    <!-- <ng-container *ngIf="purchaseOrder?.salesOrderRef"> -->
                    <div class="font-medium tracking-tight">{{purchaseOrder?.isSupplier ? 'PO' : 'SO'}} NUMBER</div>
                    <div class="font-medium">{{purchaseOrder.salesOrderRef || ('NEX-ORD-' + ((purchaseOrder.purchaseOrderId | number:'4.0')?.replace(',', '') ?? '####')) }}</div>
                    <!-- </ng-container> -->
                    <div *ngIf="purchaseOrder?.salesOrderRef2" class="font-medium tracking-tight">{{purchaseOrder?.isSupplier ? 'SO' : 'PO'}} NUMBER</div>
                    <div *ngIf="purchaseOrder?.salesOrderRef2" class="font-medium">{{purchaseOrder?.salesOrderRef2}}</div>

                    <div class="font-medium tracking-tight">TOTAL DUE</div>
                    <div class="font-medium">{{ getGrandTotal() | currency: '£' }}</div>
                </div>
                <div class="grid auto-cols-max grid-flow-col gap-x-8 -mr-16 py-6 px-8 rounded-l-2xl bg-accent dark">
                    <div class="place-self-center w-24">
                        <img
                            class="w-24"
                            [src]="themeService.getCompanyLogoDataUrl()">
                    </div>
                    <div class="pl-10 border-l text-md">
                        <div class="font-medium">{{appInfo?.companyName}}</div>
                        <div *ngIf="appInfo?.companyAddressOne">{{appInfo?.companyAddressOne}}</div>
                        <div *ngIf="appInfo?.companyAddressTwo">{{appInfo?.companyAddressTwo}}</div>
                        <div *ngIf="appInfo?.companyCity">{{appInfo?.companyCity}}</div>
                        <div *ngIf="appInfo?.companyCounty">{{appInfo?.companyCounty}}</div>
                        <div *ngIf="appInfo?.companyPostcode">{{appInfo?.companyPostcode}}</div>
                        <div *ngIf="appInfo?.companyCountry">{{appInfo?.companyCountry}}</div>
                    </div>
                </div>
            </div>

            <div class="text-md mt-6">
                <div class="text-xl font-medium">{{ contact?.name }}</div>
                <div>{{ purchaseOrder?.addressOne }}</div>
                <div>{{ purchaseOrder?.addressTwo }}</div>
                <div>{{ purchaseOrder?.city }}</div>
                <div>{{ purchaseOrder?.postcode }}</div>
            </div>

            <div class="grid gap-x-1 mt-12" [class.grid-cols-12]="!purchaseOrder?.isSupplier && !purchaseOrder?.isProduct" [class.grid-cols-9]="purchaseOrder?.isSupplier || purchaseOrder?.isProduct">
                <!-- Columns -->
                <div class="col-span-4 font-medium text-md">DESCRIPTION</div>
                <div class="col-span-1 font-medium text-md text-right" style="white-space: pre;">PRICE/{{(purchaseOrder?.isSupplier || purchaseOrder?.isProduct) ? 'ITEM' : 'DAY'}}</div>
                <div *ngIf="!purchaseOrder?.isSupplier && !purchaseOrder?.isProduct" class="col-span-3 font-medium text-md text-right">HIRE DATES</div>
                <div class="col-span-1 font-medium text-md text-right">{{(purchaseOrder?.isSupplier || purchaseOrder?.isProduct) ? 'QTY' : 'DAYS'}}</div>
                <div class="font-medium text-md text-right">VAT</div>
                <div class="col-span-2 font-medium text-md text-right">TOTAL</div>

                <!-- Divider -->
                <div class="my-4 border-b" [class.col-span-12]="!purchaseOrder?.isSupplier && !purchaseOrder?.isProduct" [class.col-span-9]="purchaseOrder?.isSupplier || purchaseOrder?.isProduct"></div>

                <!-- Item -->
                <ng-container *ngFor="let item of hireItems">
                    <div class="col-span-4 text-lg font-medium">{{ item?.description }}</div>
                    <div class="col-span-1 self-center text-right">{{ item?.price ?? 0 | currency: '£' }}</div>
                    <div class="col-span-3 self-center text-right">{{ item?.hireFrom | date:'dd/MM/yy' }} - {{ item?.hireTo | date:'dd/MM/yy' }}</div>
                    <div class="col-span-1 self-center text-right">{{ item?.quantity ?? 0 }}</div>
                    <div class="self-center text-right">{{ getVatText(item?.vat) }}</div>
                    <div class="col-span-2 self-center text-right">{{ getItemSubtotal(item) ?? 0 | currency: '£'  }}</div>
                </ng-container>
                <ng-container *ngFor="let item of partItems">
                    <div class="col-span-4 text-lg font-medium">{{ item?.description }}</div>
                    <div class="col-span-1 self-center text-right">{{ item?.price ?? 0 | currency: '£' }}</div>
                    <div class="col-span-1 self-center text-right">{{ item?.quantity ?? 0 }}</div>
                    <div class="self-center text-right">{{ getVatText(item?.vat) }}</div>
                    <div class="col-span-2 self-center text-right">{{ getItemSubtotal(item) ?? 0 | currency: '£'  }}</div>
                </ng-container>
                <ng-container *ngFor="let item of productItems">
                    <div class="col-span-4 text-lg font-medium">{{ getProductDisplayName(item) }}</div>
                    <div class="col-span-1 self-center text-right">{{ item?.price ?? 0 | currency: '£' }}</div>
                    <div class="col-span-1 self-center text-right">{{ item?.quantity ?? 0 }}</div>
                    <div class="self-center text-right">{{ getVatText(item?.vat) }}</div>
                    <div class="col-span-2 self-center text-right">{{ getItemSubtotal(item) ?? 0 | currency: '£'  }}</div>
                </ng-container>

                <!-- Spacer -->
                <div class="mt-16" [class.col-span-12]="!purchaseOrder?.isSupplier && !purchaseOrder?.isProduct" [class.col-span-9]="purchaseOrder?.isSupplier || purchaseOrder?.isProduct"></div>

                <!-- Subtotal -->
                <div class="self-center font-medium tracking-tight" [class.col-span-10]="!purchaseOrder?.isSupplier && !purchaseOrder?.isProduct" [class.col-span-7]="purchaseOrder?.isSupplier || purchaseOrder?.isProduct">SUBTOTAL</div>
                <div class="col-span-2 text-right text-lg">{{ getTotalPrice() | currency: '£' }}</div>

                <!-- Divider -->
                <div class="my-3 border-b" [class.col-span-12]="!purchaseOrder?.isSupplier && !purchaseOrder?.isProduct" [class.col-span-9]="purchaseOrder?.isSupplier || purchaseOrder?.isProduct"></div>

                <!-- Tax -->
                <div class="self-center font-medium tracking-tight" [class.col-span-10]="!purchaseOrder?.isSupplier && !purchaseOrder?.isProduct" [class.col-span-7]="purchaseOrder?.isSupplier || purchaseOrder?.isProduct">TAX</div>
                <div class="col-span-2 text-right text-lg">{{ getTotalVat() | currency: '£' }}</div>

                <!-- Divider -->
                <div class="my-3 border-b" [class.col-span-12]="!purchaseOrder?.isSupplier && !purchaseOrder?.isProduct" [class.col-span-9]="purchaseOrder?.isSupplier || purchaseOrder?.isProduct"></div>

                <!-- Freight -->
                <div class="self-center font-medium tracking-tight" [class.col-span-10]="!purchaseOrder?.isSupplier && !purchaseOrder?.isProduct" [class.col-span-7]="purchaseOrder?.isSupplier || purchaseOrder?.isProduct">FREIGHT</div>
                <div class="col-span-2 text-right text-lg">{{ purchaseOrder?.freightAmount | currency: '£' }}</div>

                <!-- Divider -->
                <div class="my-3 border-b" [class.col-span-12]="!purchaseOrder?.isSupplier && !purchaseOrder?.isProduct" [class.col-span-9]="purchaseOrder?.isSupplier || purchaseOrder?.isProduct"></div>

                <!-- Total -->
                <div class="self-center text-2xl font-medium tracking-tight" [class.col-span-10]="!purchaseOrder?.isSupplier && !purchaseOrder?.isProduct" [class.col-span-7]="purchaseOrder?.isSupplier || purchaseOrder?.isProduct">TOTAL</div>
                <div class="col-span-2 text-right text-2xl font-medium">{{ getGrandTotal() | currency: '£' }}</div>
            </div>

            <!-- <div class="mt-16">
                <div class="font-medium mt-4">Please make bank transfers payable to:</div>
                <div class="font-medium mt-4">Elevated Software Limited</div>
                <div class="font-medium">Bank Name</div>
                <div class="font-medium">Bank Address 1, Bank Address 2, Dorset, BH1 1AA</div>
                <div class="flex items-start mt-4">
                    <img
                        class="flex-0 w-24 mt-2"
                        [src]="themeService.getCompanyLogoDataUrl()">
                    <div class="ml-6 text-sm">
                        <p>Account Number: 12345678</p>
                        <p>Sort Code: 11-22-33</p>
                        <p>IBAN: XXXXXXXXXXXXXXXXXXXXXX</p>
                        <p>BIC: XXXXXXXX</p>
                    </div>
                </div>
                <div class="font-medium mt-4">Any queries must be raised within 7 days of the date of the invoice</div>
            </div> -->

        </div>
    </div>
</div>


<!-- print stuff -->
<div>
    <div [id]="'print-header-' + printSectionId" style="display: none;" class="text-left p-0 w-[63rem]">
        <div id="purchase-order-content" class="w-[67rem] p-9 rounded-none shadow-none bg-transparent" style='font-family: "arial";'>

            <div class="flex items-start justify-end">
                <div class="grid grid-cols-2 gap-x-4 gap-y-1">
                </div>
                <div class="grid auto-cols-max grid-flow-col gap-x-8 -mr-16 py-6 px-16 -ml-2 rounded-l-2xl bg-accent dark">
                    <div class="place-self-center w-28">
                        <img
                            class="w-28"
                            [src]="themeService.getCompanyLogoDataUrl()">
                    </div>
                    <div class="pl-10 border-l text-md" style="width: 340px; height: 130px;">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div [id]="'print-footer-' + printSectionId" style="display: none;">
    <img
        class="flex-0 w-36 mt-2"
        [src]="themeService.getCompanyLogoDataUrl()">
</div>
